var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-animation"},[_c('lottie-player',{staticStyle:{"width":"80px","height":"80px"},attrs:{"src":"../../../static/js/lf30_editor_TllSye.json","background":"transparent","speed":"1","color":"#000","loop":"","autoplay":""}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a9801874","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widge/LoadingAnimation.vue
// module id = null
// module chunks = 